import React, { useState, useEffect } from 'react';
import { getDayEndTimeAoe, getAoeDayKey } from '../utils/dailyUtils';
import './StreakWarningBanner.css';

const BRONZE_THRESHOLD = 500;
const WARNING_HOURS = 6;

function StreakWarningBanner({ currentStreak, dailyClicks }) {
  const [visible, setVisible] = useState(false);
  const [hoursLeft, setHoursLeft] = useState(null);
  const [dismissed, setDismissed] = useState(() => {
    return !!localStorage.getItem(`streakWarningDismissed_${getAoeDayKey()}`);
  });

  useEffect(() => {
    if (dismissed) return;

    const check = () => {
      const remaining = (getDayEndTimeAoe() - new Date()) / (1000 * 60 * 60);
      setHoursLeft(remaining);
      setVisible(
        currentStreak > 0 &&
        dailyClicks < BRONZE_THRESHOLD &&
        remaining > 0 &&
        remaining < WARNING_HOURS
      );
    };

    check();
    const interval = setInterval(check, 60000);
    return () => clearInterval(interval);
  }, [currentStreak, dailyClicks, dismissed]);

  const handleDismiss = () => {
    setDismissed(true);
    setVisible(false);
    localStorage.setItem(`streakWarningDismissed_${getAoeDayKey()}`, 'true');
  };

  if (!visible || dismissed) return null;

  const clicksNeeded = BRONZE_THRESHOLD - dailyClicks;
  const timeDisplay = hoursLeft >= 1
    ? `${Math.floor(hoursLeft)}h ${Math.floor((hoursLeft % 1) * 60)}m`
    : `${Math.floor(hoursLeft * 60)}m`;

  return (
    <div className="streak-warning-banner">
      <div className="streak-warning-content">
        <span className="streak-warning-text">
          Your {currentStreak}-day streak ends in {timeDisplay} — {clicksNeeded.toLocaleString()} more clicks to go!
        </span>
        <button className="streak-warning-dismiss" onClick={handleDismiss}>
          Got it
        </button>
      </div>
    </div>
  );
}

export default StreakWarningBanner;
